import { cn } from '@rr/ui'

/**
 * Frosted "browser window" frame used to wrap all in-page UI mockups.
 * The frame is purely cosmetic — the real product surfaces sit inside.
 */
export function MockShell({
  children,
  title,
  className,
}: {
  children: React.ReactNode
  title?: string
  className?: string
}) {
  return (
    <div
      className={cn(
        'rounded-2xl border border-border bg-card shadow-md overflow-hidden',
        className,
      )}
    >
      <div className="flex items-center gap-2 px-4 h-9 border-b border-border bg-muted/40">
        <div className="flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-muted-foreground/25" />
          <span className="w-2.5 h-2.5 rounded-full bg-muted-foreground/25" />
          <span className="w-2.5 h-2.5 rounded-full bg-muted-foreground/25" />
        </div>
        {title ? (
          <div className="flex-1 text-center text-[11px] font-mono text-muted-foreground tracking-tight truncate">
            {title}
          </div>
        ) : (
          <div className="flex-1" />
        )}
        <div className="w-10" />
      </div>
      <div className="bg-background">{children}</div>
    </div>
  )
}
